const comments = [
  {
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个站每天更新的速度真的快，早上刚看到热搜的事情，下午这里就出详细汇总了。51吃瓜在线的内容确实全，吃瓜群众的福音！',
    likes: 1286,
  },
  {
    name: '娱乐圈观察员',
    time: '5小时前',
    content: '排版清晰、分类合理，比那些广告满天飞的吃瓜平台好太多了。终于找到一个能安心在线吃瓜的地方，每日必刷！',
    likes: 967,
  },
  {
    name: '深夜吃瓜人',
    time: '1天前',
    content: '推荐给身边所有爱吃瓜的朋友了！这个瓜田太香了，内容更新及时，覆盖范围广，在线吃瓜体验一流。建议增加更多深度分析内容。',
    likes: 523,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-label text-primary-600 bg-primary-50 px-3 py-1 rounded-full">用户声音</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-3">
            吃瓜热评
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-[560px] mx-auto">
            看看吃瓜群众们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-[1100px] mx-auto">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="p-6 rounded-xl bg-background-50 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary-200 to-accent-200 flex items-center justify-center text-background-50 font-label font-bold text-sm">
                  {comment.name.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-label font-medium text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
              <div className="mt-4 pt-4 border-t border-background-200/50 flex items-center gap-4">
                <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-600 transition-colors">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes.toLocaleString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}